import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ui form" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "controls" }
const _hoisted_5 = { class: "right" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_GenratePopover = _resolveComponent("GenratePopover")

  return (_openBlock(), _createBlock(_component_GenratePopover, {
    ref: "popover",
    "vread-from": "task_error",
    "onUpdate:task_error": $event => (($data.error) = $event),
    onGenerated: $options.onGenerated
  }, {
    controls: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          small: "",
          primary: "",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$refs.popover.generate()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              icon: "stars-03",
              width: "2rem",
              height: "2rem",
              stroke: "white"
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Regenrate", -1 /* HOISTED */))
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            small: "",
            disabled: !$props.can_add || $data.error,
            onClick: _cache[2] || (_cache[2] = $event => ($options.onAppend()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                icon: "plus",
                width: "2rem",
                height: "2rem",
                stroke: "var(--gray-700)"
              }),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Append", -1 /* HOISTED */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"]),
          _createVNode(_component_Button, {
            small: "",
            primary: "",
            disabled: $data.error,
            onClick: $options.onReplace
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                icon: "refresh-cw-05",
                width: "1.6rem",
                height: "1.6rem",
                stroke: "var(--base-white)"
              }),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Replace", -1 /* HOISTED */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($props.title)
            ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString($props.title), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_TextArea, {
            modelValue: $data.generated_text,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.generated_text) = $event)),
            footer: false,
            maxlength: $props.maxlength,
            rows: $props.rows || 4
          }, null, 8 /* PROPS */, ["modelValue", "maxlength", "rows"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onUpdate:task_error", "onGenerated"]))
}